// 环境判断
const { hostname } = window.location;

export const isProduction = hostname.includes('.sf-express.com') && !hostname.includes('.sit.');
